// eslint-disable-next-line import/prefer-default-export
export enum EOnboardingStepFriendlyNames {
  creatingLibby = 'Creating Libby',
}
